import React from "react"
import {Input} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import {noDecimal} from "@irati/utils/validation/regex/number"
import {useBudgetsPermissions} from "@irati/wallet/hooks/budget"
import {InjectIntl} from "@irati/utils/lang"
import {useBudgetManagement} from "../hooks"

export function AmountInput({
  min,
  amount,
  max,
  uuid,
  formatMessage
}: {
  uuid: string
  amount: number
  max: number
  min: number
} & Pick<InjectIntl, "formatMessage">) {
  const {dispatch} = useBudgetManagement()
  const {canManageCategories} = useBudgetsPermissions()
  const amountMin = canManageCategories ? 0 : min
  const copyMin = canManageCategories
    ? "platform.validation.number.minZero"
    : "wallet.reward.budget.dashboard.validation.managerCantReduceBudget"

  return (
    <Input
      label="amount"
      placeholder="wallet.reward.budget.dashboard.placeholder.amount"
      hideLabel
      name={`${uuid}-amount`}
      className="flex-override flex-input-override"
      validation={Validation.string("platform.defaultValidation.required")
        .matches(noDecimal, "platform.validation.integersOnly")
        .test("minimum for user", copyMin, (value) => parseNum(value) >= amountMin)
        .test(
          "max of budget",
          formatMessage({id: "wallet.reward.budget.dashboard.validation.moreThanBudget"}, {amount: max / 100}),
          (value) => parseNum(value) <= max
        )}
      value={amount ? (amount / 100).toString() : "0"}
      onChange={(n) => {
        const value = parseNum(n)
        if (Number.isNaN(value) || value < 0) return
        dispatch({type: "setAmount", data: {uuid, value}})
      }}
    />
  )
}

function parseNum(str: string): number {
  return Number(str) * 100
}
